import React from 'react';

import { sortTableByLastName, sortTableFromSQLTimeStamp } from '../../../modules/sortingMethods';
import { ReactTable, Spinner } from '../../Shared/index';
import getAuthToken from '../components/modules/get_auth_token';

export default class CmsUserIndex extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      columns: this.getColumns(),
      data: props.queryResults,
      query: props.query,
      loading: false,
      showAdvanced: false,
      page: 1,
      numberOfPages: 0
    }
  }

  getColumns() {
    return [
      {
        Header: 'Name',
        accessor: 'name',
        resizable: false,
        minWidth: 120,
        sortType: sortTableByLastName,
      }, {
        Header: "Email",
        accessor: 'email',
        resizable: false,
        minWidth: 250,
      }, {
        Header: "Role",
        accessor: 'role',
        maxWidth: 80,
        resizable: false,
      }, {
        Header: "Premium",
        accessor: 'subscription',
        resizable: false,
      }, {
        Header: 'Last Sign In',
        accessor: 'last_sign_in',
        resizable: false,
        minWidth: 100,
        sortType: sortTableFromSQLTimeStamp,
        Cell: ({row}) => String(row.original.last_sign_in_text)
      }, {
        Header: "School",
        accessor: 'school',
        resizable: false,
        minWidth: 90,
        Cell: ({row}) => {
          if (row.original.school) {
            return <a href={`${window.postbuildEnv.DEFAULT_URL}/cms/schools/${row.original.school_id}`}>{row.original.school}</a>
          }
          return 'N/A';
        }
      }, {
        Header: "Edit",
        accessor: 'edit',
        resizable: false,
        maxWidth: 40,
        Cell: ({row}) => {
          return <a href={`${window.postbuildEnv.DEFAULT_URL}/cms/users/${row.original.id}/edit`}>Edit</a>
        }
      }, {
        Header: "Details",
        accessor: 'details',
        resizable: false,
        maxWidth: 60,
        Cell: ({row}) => {
          return <a href={`${window.postbuildEnv.DEFAULT_URL}/cms/users/${row.original.id}`}>Details</a>
        }
      }, {
        Header: "Sign In",
        accessor: 'sign_in',
        resizable: false,
        maxWidth: 60,
        Cell: ({row}) => {
          return <a href={`${window.postbuildEnv.DEFAULT_URL}/cms/users/${row.original.id}/sign_in`}>Sign In</a>
        }
      }
    ];
  }

  setSort = newSorted => {
    const { query, } = this.state
    if (!newSorted.length) { return }

    const sort = newSorted[0].id
    const sort_direction = newSorted[0].desc ? 'desc' : 'asc'
    if (sort !== query.sort || sort_direction !== query.sort_direction) {
      const newState = { ...this.state}
      newState.query.sort = sort
      newState.query.sort_direction = sort_direction
      this.setState(newState, this.search)
    }
  };

  toggleAdvanced = () => { this.setState(prevState => ({ showAdvanced: !prevState.showAdvanced }))};

  search = (e) => {
    const { query, } = this.state
    e ? e.preventDefault() : null;
    this.setState({loading: true})
    const link = `${window.postbuildEnv.DEFAULT_URL}/cms/users/search`
    const data = new FormData();
    Object.keys(query).forEach((k) => {
      data.append(k, query[k])
    })
    fetch(link, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      body: data,
      headers: {
        'X-CSRF-Token': getAuthToken()
      }
    }).then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    }).then((response) => {
      this.setState({ data: response.userSearchQueryResults, numberOfPages: response.numberOfPages, loading: false, page: 1 })
    }).catch((error) => {
      // to do, use Sentry to capture error
    })
  };

  submitPageForm = e => {
    e.preventDefault()
    this.updatePage(e.target.page.value)
  }

  updatePage = page => {
    this.setState({ page, })
  };

  updateField(e, key) {
    const value = e.target.value
    const newState = { ...this.state}
    newState.query[key] = value
    this.setState(newState)
  }

  updatePremiumStatus = e => {
    const selectedOptions = []
    Array.from(e.target.options).forEach(o => {
      if (o.selected) {
        selectedOptions.push(o.value)
      }
    })
    const newState = { ...this.state }
    newState.query.user_premium_status = selectedOptions
    this.setState(newState)
  };

  getPaginatedData = () => {
    const { defaultRecordLimit, } = this.props
    const { page, data, query, } = this.state;
    const recordsPerPage = defaultRecordLimit;
    const currentPage = page ? page - 1 : 0;

    const paginatedData = data.slice(currentPage * recordsPerPage, (currentPage + 1) * recordsPerPage);
    return paginatedData;
  };

  renderPageSelector() {
    const { page, numberOfPages, data, } = this.state
    const currentPage = page || 1
    const totalPages = numberOfPages || 1
    return (
      <React.Fragment>
        <p>{data.length} total records</p>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <a onClick={() => this.updatePage(1)}>First</a>
          <form onSubmit={this.submitPageForm}>
            <input aria-label="Page number" defaultValue={currentPage} name='page' /><span>of {totalPages}</span>
          </form>
          <a onClick={() => this.updatePage(totalPages)}>Last</a>
        </div>
      </React.Fragment>
    )
  }

  renderPremiumStatusSelect() {
    const { schoolPremiumTypes, } = this.props

    const options = schoolPremiumTypes.map(o => <option value={o}>{o}</option>)
    return (
      <select id="premium-status" multiple={true} onChange={this.updatePremiumStatus}>
        {options}
      </select>
    )
  }

  renderTableOrLoading() {
    const { loading, data, query, columns, numberOfPages, } = this.state
    const { defaultRecordLimit, } = this.props

    if (loading) {
      return <Spinner />
    } else if (data && data.length) {
      const paginatedData = this.getPaginatedData();
      const sort = query.sort ? query.sort : 'last_sign_in'
      const sortDescending = query.sort_direction ? query.sort_direction === 'desc' : true
      return (
        <div>
          <ReactTable
            className='progress-report activity-scores-table'
            columns={columns}
            data={paginatedData}
            defaultPageSize={30}
            defaultSorted={[{id: sort, desc: sortDescending}]}
            manualSortBy={true}
            minRows={1}
            onSortedChange={this.setSort}
          />
          <div className='cms-pagination-container'>
            {Number(query.record_limit) === defaultRecordLimit ? <p>This search returns a maximum of {defaultRecordLimit} records by default. If you need to see more records, please change the settings under Advanced Search.</p> : this.renderPageSelector()}
          </div>
        </div>
      )
    } else if (numberOfPages === 0) {
      return <p>No records found.</p>
    }

  }

  renderUserFlagsetSelect() {
    const { flagsets, } = this.props

    const options = flagsets.map(pair => <option value={pair.value}>{pair.label}</option>)
    return (
      <select id="flagset" onChange={e => this.updateField(e, 'flagset')}>
        {options}
      </select>
    )
  }

  renderUserRoleSelect() {
    const { userRoleTypes, } = this.props

    const options = [<option value />].concat(userRoleTypes.map(o => <option value={o}>{o}</option>))
    return (
      <select id="role" onChange={e => this.updateField(e, 'user_role')}>
        {options}
      </select>
    )
  }

  render() {
    const { defaultRecordLimit, } = this.props
    const { showAdvanced, query, } = this.state

    return (
      <div>
        <form acceptCharset="UTF-8" onSubmit={this.search} >
          <div className='cms-form'>
            <div className='cms-meta-middle'>
              <div className='cms-form-row'>
                <label htmlFor="user_email_exact">Email (Exact match)</label>
                <input id='user_email_exact' name='user_email_exact' onChange={e => this.updateField(e, 'user_email_exact')} value={query.user_email_exact} />
              </div>
              <div className='cms-form-row'>
                <label htmlFor="user_username">Username</label>
                <input id='user_username' name='user_username' onChange={e => this.updateField(e, 'user_username')} value={query.user_username} />
              </div>
            </div>

            <div className='cms-meta-right'>
              <div className='cms-form-row'>
                <label htmlFor="user_name">Name</label>
                <input id='user_name' name='user_name' onChange={e => this.updateField(e, 'user_name')} value={query.user_name} />
              </div>
              <div className='cms-form-row'>
                <label htmlFor="class_code">Class Code</label>
                <input id='class_code' name='class_code' onChange={e => this.updateField(e, 'class_code')} value={query.class_code} />
              </div>
            </div>
          </div>
          {showAdvanced && (
            <div className='cms-form'>
              <div className='cms-meta-middle'>
                <div className='cms-form-row'>
                  <label htmlFor="school_name">School Name</label>
                  <input id='school_name' name='school_name' onChange={e => this.updateField(e, 'school_name')} value={query.school_name} />
                </div>

                <div className='cms-form-row'>
                  <label htmlFor="user_ip">Ip</label>
                  <input id='user_ip' name='user_ip' onChange={e => this.updateField(e, 'user_ip')} value={query.user_ip} />
                </div>

                <div className='cms-form-row'>
                  <label htmlFor="flagset">Flagset</label>
                  {this.renderUserFlagsetSelect()}
                </div>
                <div className='cms-form-row'>
                  <label htmlFor="role">Role</label>
                  {this.renderUserRoleSelect()}
                </div>
              </div>
              <div className='cms-meta-right'>
                <div className='cms-form-row'>
                  <label htmlFor="user_email">Email (Partial match)</label>
                  <input id='user_email' name='user_email' onChange={e => this.updateField(e, 'user_email')} value={query.user_email} />
                </div>
                <div className='cms-form-row'>
                  <label htmlFor="premium-status">Premium Status</label>
                  {this.renderPremiumStatusSelect()}
                </div>
                <div className="cms-form-row">
                  <label htmlFor="record-limit">Record Limit</label>
                  <select
                    id="record-limit"
                    onChange={(e) => this.updateField(e, 'record_limit')}
                    value={query.record_limit || defaultRecordLimit}
                  >
                    <option value={defaultRecordLimit}>{defaultRecordLimit} Records</option>
                    <option value="all">All Records</option>
                  </select>
                </div>
              </div>
            </div>
          )}
          <div className='cms-form'>
            <div className='cms-meta-middle'>
              <p>
                <a className="link-green" onClick={this.toggleAdvanced}>{showAdvanced ? 'Hide' : 'Show'} Advanced Search</a>
              </p>
              <div className='cms-submit-row'>
                <input type="submit" value="Submit" />
              </div>
            </div>
          </div>
        </form>
        {this.renderTableOrLoading()}
      </div>
    )
  }
}
